import React from "react";

const PageHeader = ({ title, description, actions, className = "" }) => (
  <div className={`mb-6 flex flex-col sm:flex-row sm:items-center justify-between gap-4 ${className}`}>
    <div className="min-w-0 flex-1">
      <h1 className="text-[18px] sm:text-[20px] font-bold text-ink-900 dark:text-white truncate">{title}</h1>
      {description && <p className="mt-0.5 text-xs sm:text-[13px] text-ink-400 dark:text-ink-400">{description}</p>}
    </div>
    {actions && <div className="flex flex-wrap items-center gap-2.5 w-full sm:w-auto">{actions}</div>}
  </div>
);

export default PageHeader;
